import { render, staticRenderFns } from "./EditNewProject.vue?vue&type=template&id=2afe2cb6"
import script from "./EditNewProject.vue?vue&type=script&lang=js"
export * from "./EditNewProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports